import React from 'react';
import { Card } from 'semantic-ui-react';
import Image from '../../../../atoms/Image';
import BlogPostLink from '../../../../modules/blog/components/BlogPostLink/BlogPostLink';
import FormattedDate from '../../../../modules/datetime/components/FormattedDate';
import Icon from '../../../../modules/foundation/components/Icon';
import { ImagesPropType } from '../../../../services/proptypes';
import ObjectUtils from '../../../../utils/ObjectUtils';
import './BlogPostCard.css';
export default function BlogPostCard(_ref) {
  var slug = _ref.slug,
    title = _ref.title,
    publishedAt = _ref.publishedAt,
    summary = _ref.summary,
    heroImage = _ref.heroImage,
    gatsbyHeroImage = _ref.gatsbyHeroImage,
    blogRootSlug = _ref.blogRootSlug;
  return /*#__PURE__*/React.createElement(BlogPostLink, {
    slug: slug,
    blogRootSlug: blogRootSlug,
    title: title
  }, /*#__PURE__*/React.createElement(Card, {
    className: "blog-post-card"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Image, {
    className: "blog-post-card-image",
    src: gatsbyHeroImage || heroImage,
    wrapped: true
  })), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Card.Header, null, title), ObjectUtils.isRenderable(publishedAt) && /*#__PURE__*/React.createElement(Card.Meta, null, /*#__PURE__*/React.createElement(FormattedDate, {
    date: publishedAt,
    outputFormat: "PPP"
  })), /*#__PURE__*/React.createElement(Card.Description, null, summary)), /*#__PURE__*/React.createElement(Card.Content, {
    extra: true,
    textAlign: "right"
  }, /*#__PURE__*/React.createElement("p", null, "See More", /*#__PURE__*/React.createElement(Icon, {
    iconName: "arrow-right"
  })))));
}
BlogPostCard.defaultProps = {
  blogRootSlug: '/blog/',
  summary: '',
  heroImage: null,
  gatsbyHeroImage: null,
  publishedAt: null
};